import { CSSProperties, FC, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useTheme } from 'themes/themeProvider';
import { imageMap } from 'utils/imageMap';
import useWelcome from './useWelcome';

import { Loader } from 'shared';
import { useMuiTheme } from 'themes/themeMuiProvider';
import styles from './Welcome.module.scss';

import { RedirectLoginOptions } from '@auth0/auth0-react';
import { getDomainAndSubdomain } from 'utils/domain';

type RedirectLoginOptionsWithOrg = RedirectLoginOptions & {
  organization?: string;
};

export const Welcome: FC = () => {
  const muiTheme = useMuiTheme();
  const { theme } = useTheme();

  const logoUrl = imageMap.logos[theme.logo.imageId];
  const backgroundURL = imageMap.backgrounds[theme.background];

  const logoStyle: CSSProperties = {
    '--logo-url': `url(${logoUrl})`,
    '--logo-height': theme.logo.height,
    '--logo-width': theme.logo.width,
  } as React.CSSProperties;

  const containerStyle: CSSProperties = {
    '--background-url': `url(${backgroundURL})`,
    '--background-color': theme.headerColor,
  } as React.CSSProperties;

  const { showErrorNotification, loginWithRedirect } = useWelcome();

  const ORG_IDS: Record<string, string> = {
    amityage: process.env.REACT_APP_AUTH0_ORG_ID_AMITYAGE!,
    'cryptohall24-duerr': process.env.REACT_APP_AUTH0_ORG_ID_CRYPTOHALL_DUERR!,
    'cryptohall24-quetta': process.env.REACT_APP_AUTH0_ORG_ID_CRYPTOHALL_QUETTA!,
  };

  useEffect(() => {
    const doLogin = async () => {
      try {
        const { subdomain } = getDomainAndSubdomain();
        const orgId = ORG_IDS[subdomain.toLowerCase()];

        if (!orgId) {
          await loginWithRedirect();
        }

        await loginWithRedirect({
          organization: orgId,
        } as any);
      } catch (err) {
        console.error('Login redirect error:', err);
      }
    };

    const timer = setTimeout(doLogin, 1500);
    return () => clearTimeout(timer);
  }, [loginWithRedirect]);

  return (
    <>
      <div className={styles.container} style={containerStyle}>
        <Link to='/'>
          <div className={styles.logo} style={logoStyle} />
        </Link>
        <Loader className={styles.loader} color={muiTheme.loader.color} />
      </div>

      {showErrorNotification && (
        <div className={styles.errorNotification}>Something went wrong, please try again later</div>
      )}
    </>
  );
};
